<div *ngIf="location"
     class="location-label"
     [class.checked-in]="lcoService.checkedIn$ | async">

  <span>{{ location }}{{ tableNumber ? ', table ' + tableNumber : '' }}</span>

  <div *ngIf="lcoService.checkedIn$ | async" class="chat-bot">
    <span class="chat-bot-label">If you need anything, ask Jack</span>

    <button
      mat-button
      class="chat-bot-button"
      (click)="openChatBot()">
      <img lazyLoad
           src="../../../../assets/img/bot-avatars/JACKS_LCO_ChatBotIcons_240px.png"
           alt="Open Chat Bot"
           class="btn-image">
    </button>
  </div>
</div>


